import { render, staticRenderFns } from "./insurer-alert-msg.vue?vue&type=template&id=c21a810e&"
import script from "./insurer-alert-msg.vue?vue&type=script&lang=js&"
export * from "./insurer-alert-msg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./insurer-alert-msg-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ftasks%2Fcommon%2Finsurer-alert-msg.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports